export { VpMediaSubmissionDetailsDialog } from './VpMediaSubmissionDetailsDialog';



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/index.js